module.exports = __webpack_public_path__ + "static/media/shi.78303f48.png";